export const CONVERSATIONS_PAGE = 'reports/conversations/CONVERSATIONS_PAGE'
